import { type FC, useMemo } from 'react';
import { MiniGrid } from '@direct-frontend/components';
import { type OpenApiSchemaProductVariant } from '#shared/api/schema';
import { useLimitedGridRows } from '#shared/lib/hooks';
import { AddonRow } from './components/AddonRow';
import { Wrapper } from './components/Wrapper';
import { useGetProductAddons } from '../../api';

export type ProductAddonsIslandProps = {
    productId: OpenApiSchemaProductVariant['id'];
    gridSettings?: {
        limitRows: number;
        step?: number;
    };
};

export const ProductAddonsIsland: FC<ProductAddonsIslandProps> = ({
    productId,
    gridSettings = { limitRows: Infinity },
}) => {
    const { data: addons = [] } = useGetProductAddons({ params: { id: productId } });

    const rows = useMemo(() => addons.map((addon) => <AddonRow key={addon.id} addon={addon} />), [addons]);

    const limitedRows = useLimitedGridRows({
        rows,
        limit: gridSettings.limitRows,
        step: gridSettings.step,
    });

    return <Wrapper>{rows.length > 0 ? <MiniGrid>{limitedRows}</MiniGrid> : null}</Wrapper>;
};
